import styled from 'styled-components';
import React, { useHistory, useLocation, useParams } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import { _ } from '_locales';
import { connect } from 'react-redux';
import { eventTracker } from '_helpers';
import ResultItem from './components/ResultItem';
import { Container } from '../Quiz/styles';
import { Button } from '../Education/components';
import events from '../Education/events';

const quizType = {
  rf: {
    quiz: 'rfQuiz',
    data: 'recyclingFundamentals',
    landEvent: events.DZ_RF_QUIZ_RESULTS_LAND,
    takeTestAgainEvent: events.DZ_RF_QUIZ_RESULTS_TAKE_TEST_AGAIN_TAP,
    viewAllEvent: 'DZ_RF_QUIZ_RESULTS_VIEW_ALL_TAP'
  },
  mum: {
    quiz: 'mumQuiz',
    data: 'misundestoodMaterials',
    landEvent: events.DZ_MM_QUIZ_RESULTS_LAND,
    takeTestAgainEvent: events.DZ_MM_QUIZ_RESULTS_TAKE_TEST_AGAIN_TAP,
    viewAllEvent: 'DZ_MM_QUIZ_RESULTS_VIEW_ALL_TAP'
  }
};

const Title = styled.h3`
  margin-bottom: 10px;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  margin: 30px auto;
  justify-content: center;
`;

const QuizResults = ({ quizState }) => {
  const { state } = useLocation();
  const [showAll, setShowAll] = useState(false);
  const { type } = useParams();
  const { replace } = useHistory();
  const quizes = state?.isLearningModule ? quizState[quizType[type].quiz][state.lmIndex]
    : quizState[quizType[type].quiz];

  const windowRef = useRef(window);

  const title = (type === 'rf') ? _('education.recycling_fundamentals') : _('education.misunderstood_materials');

  const { total, ...quizItems } = quizes;

  const didPass = Object
    .keys(quizes)
    .map((key) => quizes[key])
    .filter(({ passed }) => passed).length >= (total - 1);

  const haveAtLeastOneMistake = Object
    .keys(quizes)
    .map((key) => quizes[key])
    .some(({ failed }) => failed);

  useEffect(() => {
    eventTracker(quizType[type].landEvent, '');
  }, [type]);

  return (
    <div>
      <Container>
        {type !== 'lm' ? (
          <Title>
            {title}
            {' '}
            -
            {' '}
            {_('education.answer_sheet')}
          </Title>
        ) : (
          <Title>
            {_('education.answer_sheet')}
          </Title>
        )}
        {Object.keys(quizItems).map((key) => quizes[key]).map((data) => (
          <ResultItem
            key={data.id}
            data={data}
            showCorrectAnswers={showAll}
          />
        ))}

        <ButtonContainer>
          {!didPass ? (
            <Button
              style={{ flex: 1 }}
              className="btn filled royal"
              onClick={() => {
                eventTracker(quizType[type].takeTestAgainEvent, '');
                replace(`/quiz/${type}/0`, {
                  lmIndex: state?.lmIndex,
                  isLearningModule: state?.isLearningModule
                });
              }}
            >
              {_('education.take_the_test_again')}
            </Button>
          ) : null}

          {haveAtLeastOneMistake ? (
            <Button
              style={{ flex: 1 }}
              className="btn outline royal"
              onClick={() => {
                windowRef.current.scrollTo(0, 0);
                if (!showAll) eventTracker(quizType[type].viewAllEvent, '');
                return setShowAll(!showAll);
              }}
            >
              {
                showAll
                  ? _('education.hide_correct_answers')
                  : _('education.view_all_answers')
              }
            </Button>
          ) : null}

          <Button style={{ flex: 1 }} onClick={() => replace('/education')}>
            {_('education.quit')}
          </Button>
        </ButtonContainer>
      </Container>
    </div>
  );
};

const mapStateToProps = (state) => ({
  quizData: state.quiz.quizData,
  quizState: state.quiz.quizState,
});

export default connect(mapStateToProps, null)(QuizResults);
